import * as React from "react";

import { useVizState } from "@/shared/state/visualization";

import { vizConfigToLayout } from "../VizConfigToLayout";

export function useGetWorkingStateAsLayout() {
  const state = useVizState();

  return React.useCallback(() => {
    const layoutDefinition = vizConfigToLayout(state);
    return {
      schema_version: layoutDefinition.schemaVersion,
      layout_definition: layoutDefinition.state,
    };
  }, [state]);
}
